import React from 'react'
import { Inertia } from '@inertiajs/inertia'
import AppLayout from '@/Layouts/AppLayout'
import OrganizationLayout                                                from '@/Layouts/OrganizationLayout'
import { useTitle } from '@/Utilities/Hooks'
import Row from "@/Components/Users/Row";
import {Tab, Tabs} from "@/Components/Tabs";
import LayoutIcon from "@/Components/LayoutIcon";
import {Users as UsersIcon} from "@/Icons";

export default function Index({users}) {
    useTitle('Handle organization users');

    let tabs = [
        'All Users',
    ];

    return (
        <>
            <Tabs items={tabs}>
                <Tab>
                    <div className="my-3">
                        {users.data.map((u, i) => (
                            <Row key={u.id} user={u} />
                        ))}
                    </div>
                </Tab>
            </Tabs>
        </>
    )
}

Index.layout = page => (
    <AppLayout title="Users">
        <OrganizationLayout
            header="Users"
            byline="Go to your team’s emission accounting to add and se status of activitites"
            action={{ label: 'Invite users', callback: () => Inertia.visit('users/invite') }}
            icon={<LayoutIcon><UsersIcon size={40} className="text-black"/></LayoutIcon>}
        >
            {page}
        </OrganizationLayout>
    </AppLayout>
)
